"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiHttpLink = createApiHttpLink;
const client_1 = require("@apollo/client");
const create_client_http_headers_1 = require("./utils/create-client-http-headers");
function createApiHttpLink({ uri, ...clientHeadersParams }) {
    const headers = (0, create_client_http_headers_1.createClientHttpHeaders)(clientHeadersParams);
    return (0, client_1.createHttpLink)({
        uri,
        headers,
    });
}
//# sourceMappingURL=apiHttpLink.js.map